export default __webpack_public_path__ + "static/anr-btn2-c0c9271add62e1105c539d5117e7e717.png";